import React from 'react';
import { Stage, Container } from '@pixi/react';
import BoardSprite from "../PixiGame/BoardSprite"
import PixiAnimatedContainer from '../PixiGame/PixiAnimatedContainer';
import { boardTileSize } from '../../env';
import { utils } from '../../utils';

export default class PreReleaseLandingPage extends React.Component
{
  handleClickedDiscordButton = () =>
  {
    window.open( 'https://discord.gg/9qg5E8fCQQ', '_blank' );
  };

  render()
  {
    let mobileMode = false;

    if( window.innerWidth < window.innerHeight )
    {
      mobileMode = true;
    }

    const tileFolderName = "v1"; //"legacy"; //"v1";
    const stageWidth = 800;
    const stageHeight = 800;
    const tileOverlayOffset = 5;
    const renderScale = 0.6;
    const placementDelay = 700;

    const TILE = "tile";
    const MEEPLE = "meeple";

    const tilePlacementAnimSteps =
      [
        {
          fromOffsetX: 0,
          fromOffsetY: -50,
          fromAlpha: 0,
          toOffsetX: 0,
          toOffsetY: 0,
          toAlpha: 1,
          duration: 1500, // ms
          easing: "inOutSine"   // TODO: Add support for different easing functions
        }
      ];

    const meeplePlacementAnimSteps =
      [
        {
          fromOffsetX: 0,
          fromOffsetY: -50,
          fromAlpha: 0,
          toOffsetX: 0,
          toOffsetY: 0,
          toAlpha: 1,
          duration: 500, // ms
          easing: "inOutSine"   // TODO: Add support for different easing functions
        } ];

    const gameDemoAnimSequenceData = [
      {
        type: TILE,
        sprite: "base_20",
        x: 0,
        y: 0
      },
      {
        type: TILE,
        sprite: "base_11",
        x: 0,
        y: 1,
        delay: placementDelay,
        angle: 180
      },
      {
        type: MEEPLE,
        x: 0,
        y: 1,
        meepleX: 0.25,
        meepleY: -0.1,
        isFarmer: false,
        colour: "red",
        delay: placementDelay
      },
      {
        type: TILE,
        sprite: "base_22",
        x: -1,
        y: 0,
        delay: placementDelay,
        angle: 180
      },
      {
        type: MEEPLE,
        x: -1,
        y: 0,
        meepleX: 0.25,
        meepleY: 0.1,
        isFarmer: false,
        colour: "green",
        delay: placementDelay
      },
      {
        type: TILE,
        sprite: "base_15",
        x: 0,
        y: -1,
        delay: placementDelay,
        angle: 90
      },
      {
        type: MEEPLE,
        x: 0,
        y: -1,
        meepleX: 0.4,
        meepleY: 0.1,
        isFarmer: false,
        colour: "blue",
        delay: placementDelay
      },

      {
        type: TILE,
        sprite: "base_2",
        x: 1,
        y: 0,
        delay: placementDelay,
        angle: 90
      },
      {
        type: MEEPLE,
        x: 1,
        y: 0,
        meepleX: 0,
        meepleY: 0,
        isFarmer: false,
        colour: "red",
        delay: placementDelay
      },

      {
        type: TILE,
        sprite: "base_9",
        x: -1,
        y: -1,
        delay: placementDelay,
        angle: 180
      },
      {
        type: MEEPLE,
        x: -1,
        y: -1,
        meepleX: 0.4,
        meepleY: 0.1,
        isFarmer: false,
        colour: "green",
        delay: placementDelay
      },
      {
        type: TILE,
        sprite: "base_12",
        x: 1,
        y: -1,
        delay: placementDelay,
        angle: 0
      },
      {
        type: MEEPLE,
        x: 1,
        y: -1,
        meepleX: -0.03,
        meepleY: 0.42,
        isFarmer: true,
        colour: "blue",
        delay: placementDelay
      },
      {
        type: TILE,
        sprite: "base_5",
        x: 1,
        y: 1,
        delay: placementDelay,
        angle: 0
      },
      {
        type: TILE,
        sprite: "base_17",
        x: -1,
        y: 1,
        delay: placementDelay * 2,
        angle: 270
      },
      {
        type: MEEPLE,
        x: -1,
        y: 1,
        meepleX: -0.35,
        meepleY: 0.05,
        isFarmer: false,
        colour: "green",
        delay: placementDelay
      },
    ];

    let boardSprites = [];
    let delayOffset = 0;

    for( let idx = 0; idx < gameDemoAnimSequenceData.length; idx++ )
    {
      let data = gameDemoAnimSequenceData[ idx ];
      let delay = ( data.delay ?? 0 ) + delayOffset;

      delayOffset += ( data.delay ?? 0 );

      if( data.type == TILE )
      {
        // NOTE: I broke this when migrating to PixiAnimatedContainer. Needs fixing...
        boardSprites.push(
          <PixiAnimatedContainer
            key={ "board-sprite-" + idx }
            renderScale={ renderScale }
            x={ ( data.x * boardTileSize ) + ( stageWidth / 2 ) }
            y={ ( ( data.y * -1 ) * boardTileSize ) + ( stageWidth / 2 ) }
            animSteps={ tilePlacementAnimSteps }
            delay={ delay }
          >
            <BoardSprite
              imageSrc={ `./tiles/${tileFolderName}/tile_${data.sprite}.png` }
              renderScale={ renderScale }
              angle={ data.angle ?? 0 }
            />
            <BoardSprite
              imageSrc={ `./tiles/${tileFolderName}/base-tile-overlay.png` }
              renderScale={ renderScale }
              x={ tileOverlayOffset }
              y={ -tileOverlayOffset }
            />
          </PixiAnimatedContainer>
        );
      }
      else if( data.type == MEEPLE )
      {
        boardSprites.push(
          <BoardSprite
            key={ "board-sprite-" + idx }
            imageSrc={ utils.getAssetPath(`./meeples/Meeple - ${data.isFarmer ? 'Farmer' : 'Standard'} - ${data.colour}.png`) }
            renderScale={ renderScale }
            offsetX={ stageWidth / 2 }
            offsetY={ stageHeight / 2 }
            x={ data.x + data.meepleX }
            y={ data.y * -1 - data.meepleY }
            animSteps={ meeplePlacementAnimSteps }
            delay={ delay }
          />
        );
      }
    }





    return (
      <>

        <Stage
          width={ stageWidth }
          height={ stageHeight }
          options={ { backgroundColor: 0xDEE8E5 } }
          className='landing-page-pixi-stage'
          style={ {
            touchAction: "none",
            position: "absolute",
            display: "block",
            left: mobileMode ? "50%" : "calc(50% - 300px)",
            top: mobileMode ? "480px" : "50%",
            transform: mobileMode ? "translate(-50%, 0%)" : "translate(-50%, -50%)",
            // border: "2px solid black"
          } }
        >
          <Container>
            { boardSprites }
          </Container>
        </Stage>




        <div className={ mobileMode ? 'landing-page-mobile-top-panel' : 'landing-page-right-panel' }>

          <img src={ process.env.PUBLIC_URL + '/meeples-logo-256.png' } className="landing-page-meeples-logo" alt="Meeples Logo" />

          <div className="landing-page-game-statement">#1 Free Online Carcassonne Alternative</div>

          <div className="landing-page-coming-soon">Coming Soon</div>

          <button className='landing-page-discord-button colour-dark-accent-bg panel-button' onClick={ this.handleClickedDiscordButton } >
            JOIN OUR DISCORD
            <img src={ process.env.PUBLIC_URL + 'ui/discord-logo-white.png' } alt="discord-icon" />
          </button>
        </div>
      </>
    );
  }
}
